import { ExperienceStepTwoInitialValues } from "../types/experience.types";

export const EXPERIENCE_STEP_TWO_INITIAL_VALUES: ExperienceStepTwoInitialValues = {
    jobTitle: null,
    department: null,
    subDepartment: null,
    company: null,
    industry: null,
    skills: [],
    startDate: null,
    endDate: null,
    currentlyWorkingHere: null,
    currentMonthlySalary: null,
    employmentType: null,
    noticePeriod: null,
    start: null,
    end: null,
};
